import { writable, get } from 'svelte/store';
import * as api from '../../utiles/api.js';
import toast from "svelte-french-toast";

const today = new Date();
const fourMonthsAgo = new Date();
fourMonthsAgo.setMonth(today.getMonth() - 4);

const formatDate = (date) => date.toISOString().split('T')[0];

export const processNonconformityStore = writable({
    list: [],
    selectedItem: null,
    details: [],
    defectPhotos: [],
    actionDetails: [],
    actionPhotos: [],
    search: {
        prdctn_plan_no: '',
        item_code: '',
        item_nm: '',
        startDate: '2025-01-01',
        endDate: '2026-12-31',
        inspct_empno: '',
        search_korean_nm: '',
        isExpanded: true
    },
    scrollPos: 0
});

export const appStateStore = writable({
    currentView: 'list', // 'list' or 'detail'
    selectedId: null
});

// 데이터 호출 함수 (전역 관리)
export async function fetchProcessNonconformityData(bplc_code, silent = false) {
    const store = get(processNonconformityStore);
    try {
        const params = new URLSearchParams({
            bplc_code: bplc_code || "01",
            startDate: store.search.startDate || "",
            endDate: store.search.endDate || "",
            prdctn_plan_no: store.search.prdctn_plan_no || "",
            item_code: store.search.item_code || "",
            item_nm: store.search.item_nm || "",
            inspct_empno: store.search.inspct_empno || "",
            search_korean_nm: store.search.search_korean_nm || ""
        });

        const response = await api.get(`process-nonconformity/list?${params.toString()}`);

        if (response && response.data) {
            processNonconformityStore.update(s => ({
                ...s,
                list: response.data
            }));
            if (!silent) toast.success("공정부적합 조회 완료");
        }
    } catch (err) {
        console.error(err);
        if (!silent) toast.error("공정부적합 조회 중 오류가 발생했습니다.");
    }
}

// 상세 리스트 조회 (재사용)
export async function fetchProcessNonconformityDetail(item) {
    try {
        const params = new URLSearchParams({
            bplc_code: item.bplc_code || "01",
            prdctn_plan_no: item.prdctn_plan_no,
            odr: item.odr,
        });

        const response = await api.get(`process-nonconformity/detail?${params.toString()}`);
        if (response && response.data) {
            processNonconformityStore.update(s => ({
                ...s,
                details: response.data
            }));
        }
    } catch (err) {
        console.error("Error fetching detail:", err);
    }
}
